import Segment from '@components/Segment/Segment';
import { SchemaTypeIds } from '@contentchef/contentchef-types';
import withDefinitionErrors, { WithDefinitionErrorsReturnProps } from '@hoc/withDefinitionErrors/withDefinitionErrors';
import withExtensionAPI from '@hoc/withExtensionAPI';
import { useExtensionAPIStore } from '@hooks/mobx';
import { Form } from 'antd';
import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import Select from '../Fields/Select';

interface ExtensionProps extends WithDefinitionErrorsReturnProps, InjectedIntlProps {
    value?: string;
    type: SchemaTypeIds;
    onChange(value?: string): any;
}

function Extension(props: ExtensionProps) {

    const extensionAPIStore = useExtensionAPIStore();

    useEffect(
        () => {
            async function list() {
                await extensionAPIStore.setExtensions();
            }
            list();
        },
        [extensionAPIStore]
    );

    function buildOptions() {
        return extensionAPIStore.extensions
            .filter(extension => extension.supportedTypes.includes(props.type))
            .map(extension => {
                return {
                    value: extension.mnemonicId,
                    label: extension.name
                };
            });
    }

    return (
        <Segment
            divider={true}
            title={
                <FormattedMessage
                    id="omponents.ContentDefinitionSchemaEditor.ContentDefinitionFieldEditing.Extension"
                    defaultMessage="Extension"
                />
            }
            titleVariant="label"
        >
            <Form.Item
                help={props.hasErrors ? props.errors.map(e => props.intl.formatMessage(e)).join(', ') : undefined}
                validateStatus={props.hasErrors ? 'error' : undefined}
                style={{ width: '100%' }}
            >
                <Select
                    onChange={props.onChange}
                    value={props.value}
                    options={buildOptions()}
                />
            </Form.Item>
        </Segment>
    );
}

export default injectIntl(withDefinitionErrors(withExtensionAPI(observer(Extension))));
